<template>
	<form @submit.prevent="save">
		<vs-card class="flex flex-col justify-between p-5" fixedHeight style="min-height: 70vh">
			<ResponseAlert ref="response" />
			<h3>Detail</h3>

			<div class="w-full flex-col md:flex-row my-5 flex">
				<div class="w-full md:w-1/4 border-solid border-grey border-0 md:border-r md:mr-12 md:pr-5  flex flex-col justify-evenly">
					<div class="field">
						<label class="text-base">Date</label>
						<p class="text-base font-bold">{{models.date}}</p>
					</div>
					<div class="field my-3">
						<label class="text-base">Status</label>
						<p class="text-base font-bold" :class="textColor(models.status)">{{models.statusText}}</p>
					</div>
					<div class="field">
						<label class="text-base">Type</label>
						<p class="text-base font-bold">{{models.transactionId ? 'Giveaway' : 'Redeem'}}</p>
					</div>
					<div class="field my-3" v-if="models.status === 2 || models.status === 3">
						<label class="text-base">Receipt</label>
						<p class="text-base font-bold" style="overflow-wrap: break-word;">{{models.expedition}} - {{models.awb || models.receipt}}</p>
					</div>
					<vs-button v-if="models.status === 2" class="mx-2 mb-2" @click="popupActivo=true" color="primary" type="border">Update receipt</vs-button>
					<vs-popup title="" :active.sync="popupActivo" button-close-hidden>
						<form @submit.prevent="updateReceipt">
							<vs-input
								v-validate="'required'"
								label="Expedition"
								name="expedition"
								type="text"
								v-model="vars.expedition"
								class="w-full"/>
								<span class="text-danger text-sm" v-show="errors.has('expedition')">{{ errors.first('expedition') }}</span>
							<vs-input
								v-validate="'required'"
								label="Input Receipt Number"
								name="receipt"
								type="text"
								v-model="vars.receipt"
								@keydown.space.prevent
								class="w-full"/>
							<span class="text-danger text-sm" v-show="errors.has('receipt')">{{ errors.first('receipt') }}</span>
							<vs-row class="mt-5">
								<vs-col vs-type="flex" class="flex-row" vs-lg="8" vs-w="12">
									<vs-row>
										<vs-col vs-type="flex" vs-lg="5" class="pr-1">
											<vs-button button="submit" @click="updateReceipt" class="w-full px-0" color="success">Submit</vs-button>
										</vs-col>
										<vs-col vs-type="flex" vs-lg="5" class="pl-1">
											<vs-button @click="popupActivo = false" class="w-full px-0" color="danger">Cancel</vs-button>
										</vs-col>
									</vs-row>
								</vs-col>
							</vs-row>
						</form>
					</vs-popup>
				</div>
				<div class="w-full md:w-3/4 mt-4 lg:mt-0">
					<div class="field">
						<label class="text-base uppercase font-bold">Product</label>
						<div class="flex items-center" v-if="models.product">
							<div class="w-32 h-32 mr-3">
								<img class="h-full w-full object-cover bg-grey" :src="models.product.image" alt="image-product">
							</div>
							<div class="description" v-if="models.product">
								<p class="text-base font-bold my-3">{{models.product.name}}</p>
								<p class="text-base my-3">{{models.product.point}} Point - IDR {{price}}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<vs-divider />

			<h3>User Claim</h3>
			<div class="w-full my-5 flex flex-col lg:flex-row justify-between">
				<div class="w-full lg:w-5/12 border-solid border-0 border-grey lg:border-r" v-if="models.user">
					<div class="field">
						<div class="flex items-center">
							<div class="w-32 h-32 mr-3">
								<img class="h-full w-full object-cover bg-grey rounded-lg" :src="getUrlOfFile(models.user.image)" alt="image-product">
							</div>
							<div class="description">
								<p class="text-base mb-1 font-bold">{{models.user.name}}</p>
								<a class="text-base">{{models.user.account && models.user.account.email}}</a>
								<p class="text-base my-1">{{bod}}</p>
								<p class="text-base mb-1">{{contentTypes}}</p>
							</div>
						</div>
					</div>
				</div>
				<div class="w-full lg:w-3/12 flex flex-col justify-evenly border-solid border-0 border-grey lg:border-r my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Address</label>
						<p class="text-base font-bold">{{address}}</p>
					</div>
					<div class="field">
						<label class="text-base">Phone Number</label>
						<p class="text-base font-bold">{{models.phoneNumber}}</p>
					</div>
				</div>
				<div class="w-full lg:w-3/12 flex flex-col justify-evenly my-3 lg:my-0">
					<div class="field">
						<label class="text-base">Point Withdraw</label>
						<p class="text-base font-bold">{{models.point_withdraw}}</p>
					</div>
					<div class="field">
						<label class="text-base">Point Balance</label>
						<p class="text-base font-bold">{{models.point_balance}}</p>
					</div>
				</div>
			</div>

			<vs-divider />

      <!-- <h3>Information</h3>
			<div class="w-full my-5 flex flex-col lg:flex-row">
				<div class="flex flex-col space-y-4 w-full lg:w-1/2 border-solid border-0 border-grey border-b pb-5 md:pb-0 md:border-b-0 lg:border-r md:mr-12" v-if="models.user">
          <div class="field">
						<div class="flex flex-col space-x-2 items-center">
              <div class="flex items-center space-x-2 w-16 description">
                <p class="text-base mb-1 font-bold">KTP</p>
								<span class="text-base cursor-pointer" @click="zoomImage('ktp')">
                  <vs-icon icon="zoom_in"></vs-icon>
                </span>
								<span class="text-base cursor-pointer" @click="downloadImage('ktp')">
                  <vs-icon icon="file_download"></vs-icon>
                </span>
							</div>
              <div class="w-full md:w-1/2 h-64 mr-3">
                <img class="h-full w-full object-cover bg-grey rounded-lg cursor-pointer" :src="getUrlOfFile(models.ktpUrl)" alt="image-product" @click="zoomImage('ktp')">
              </div>
						</div>
					</div>
          <div class="field">
						<div class="flex flex-col space-x-2 items-center">
              <div class="flex items-center space-x-2 w-16 description">
                <p class="text-base mb-1 font-bold">NPWP</p>
								<span class="text-base cursor-pointer" @click="zoomImage('npwp')">
                  <vs-icon icon="zoom_in"></vs-icon>
                </span>
                <span class="text-base cursor-pointer" @click="downloadImage('npwp')">
                  <vs-icon icon="file_download"></vs-icon>
                </span>
							</div>
              <div class="w-full md:w-1/2 h-64 mr-3">
                <img class="h-full w-full object-cover bg-grey rounded-lg cursor-pointer" :src="getUrlOfFile(models.npwpUrl)" alt="image-product" @click="zoomImage('npwp')">
              </div>
						</div>
					</div>
				</div>
				<div class="w-full lg:w-1/2 flex flex-col justify-center space-y-6 border-solid border-0 border-grey my-3 lg:my-0">
          <div class="field">
            <label class="text-base">Nama Bank</label>
            <p class="text-base font-bold">{{models.bankName}}</p>
          </div>
					<div class="field">
						<label class="text-base">No. Rekening</label>
						<p class="text-base font-bold">{{models.bankNumber}}</p>
					</div>
					<div class="field">
						<label class="text-base">Nama Penerima</label>
						<p class="text-base font-bold">{{models.bankAccountHolder || '-'}}</p>
					</div>
				</div>
			</div> -->

      <vs-popup fullscreen title="" :active.sync="zoomPopup">
        <div class="flex items-center justify-center">
          <img class="w-full h-full" :src="activeImage === 'ktp' ? models.ktpUrl : models.npwpUrl" alt="">
        </div>
      </vs-popup>


			<!-- Button Action -->
			<div class="w-1/2 mt-20 flex justify-between flex-col md:flex-row m-auto">
				<vs-button class="w-full mb-3 mx-1 text-center" color="rgb(172,172,172)" type="filled" @click="$router.go(-1)">Back</vs-button>
				<vs-button @click="updateClaim(1)" v-if="models.status === 0 && !models.transactionId" class="w-full mb-3 mx-1 text-center" color="warning" type="filled">Processing</vs-button>
				<vs-button @click="updateClaim(4)" v-if="models.status === 0 && !models.transactionId" class="w-full mb-3 mx-1 text-center" color="danger" type="filled">Rejected</vs-button>
				<vs-button @click="updateClaim(2)" v-if="models.status === 1" class="w-full mb-3 mx-1 text-center" color="primary" type="filled">Send Product</vs-button>
				<!-- <vs-button @click="updateClaim(3)" v-if="models.status === 2" class="w-full mb-3 mx-1 text-center" color="success" type="filled">Completed</vs-button> -->
			</div>
		</vs-card>
	</form>
</template>

<script>
	import api from '@/utils/api.js'
	import moment from 'moment'
	import {
		getUrlOfFile
	} from '@/utils/helpers.js';

	export default {
		name: 'DetailClaim',
		data() {
			return {
				popupActivo: false,
				config: {
					uri: this.$route.meta.link,
				},
				models: {
					date: '',
					status: '',
					product: null,
					user: null,
					address: '',
					phone: '',
					point_withdraw: '-',
					point_balance: '-',
					statusNumber: 0,
					receipt: null,
					expedition: null,
					transactionId: null,
          bankName: '',
          bankNumber: '',
          bankAccountHolder: '',
          ktpUrl: '',
          npwpUrl: ''
				},
				vars: {
					receipt: '',
					expedition: ''
				},
				getUrlOfFile,
				moment,
        zoomPopup: false,
        activeImage: '',
			}
		},
		computed: {
			price() {
				return parseFloat(this.models.product.price).toLocaleString().replace(/[.,]/g, m => m === '.' ? ',' : '.')
			},
			bod() {
				return this.models.user.bod ? moment(this.models.user.bod).format('DD MMMM YYYY') : '-'
			},
			address() {
				return [this.models.province, this.models.regency, this.models.district, this.models.village, this.models.address, this.models.postalCode].filter(data => data !== '-').join(', ')
			},
			contentTypes() {
				return this.models.user.contentTypes.map(content => content.name).join(', ')
			}
		},
		created() {
			this.getById();
		},
		methods: {
			textColor(status) {
				switch (status) {
					case 0:
						return 'text-warning'
					case 1:
					case 2:
					case 3:
						return 'text-success'
					case 4:
						return 'text-danger'
					default:
						break;
				}
			},
			getById() {
				if (this.$route.params.id) {
					this.$axios.get(`${api.redeems}/${this.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							this.models.date = moment(data.createdAt).format('DD MMMM YYYY');
							this.models.statusText = data.internalStatus
							this.models.status = data.status
							this.models.product = data.product
							this.models.user = data.user
							this.models.receipt = data.receipt
							this.models.awb = data.awb
							this.models.expedition = data.expedition
							this.models.address = data.address
							this.models.province = data.province ? data.province.name : '-'
							this.models.regency = data.regency? data.regency.name : '-'
							this.models.district = data.district ? data.district.name : '-'
							this.models.village = data.village ? data.village.name : '-'
							this.models.postalCode = data.postalCode
							this.models.phoneNumber = data.phoneNumber
							this.models.point_withdraw = data.balance && (data.balance.totalWithdraw || 0)
							this.models.point_balance = data.balance && (data.balance.totalRedeem || 0)
							this.vars.receipt = data.receipt
							this.vars.expedition = data.expedition
							this.models.transactionId = data.transactionId
							this.models.bankName = data.bankName
							this.models.bankNumber = data.bankNumber
              this.models.bankAccountHolder = data.receiptName
              this.models.ktpUrl = data.ktpUrl
              this.models.npwpUrl = data.npwpUrl
						}).catch(() => this.$router.push({
							name: 'page404'
						}));
				}
			},
			updateReceipt() {
				this.$validator.validate().then(valid => {
					if(valid) {
						this.$axios.put(`${api.redeems}/${this.$route.params.id}/receipt`, {
							receipt: this.vars.receipt,
							expedition: this.vars.expedition
						})
						.then(res => {
							this.$refs.response.setResponse(res.data, 'success');
							this.vars.receipt = ''
							this.vars.expedition = ''
							this.popupActivo = false
							this.getById()
						})
						.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
					}
				})
			},
			updateClaim(status) {
				// status: (0: waiting process, 1: processing, 2: product-sent, 3: product-receive, 4: reject)
				this.$axios.put(`${api.redeems}/${this.$route.params.id}/status`, {
					status
				})
					.then(res => {
						this.$refs.response.setResponse(res.data, 'success');
						this.getById()
					})
					.catch(error => this.$refs.response.setResponse(error.response.data, 'danger'))
			},
      zoomImage(type) {
        this.activeImage = type

        if (this.models.ktpUrl || this.models.npwpUrl) {
          this.zoomPopup = true
        }
      },
      downloadImage(type) {
        if (this.models.ktpUrl || this.models.npwpUrl) {

          fetch(type === 'ktp' ? this.models.ktpUrl : this.models.npwpUrl)
            .then(response => {
              if (response.headers.get('content-type').startsWith('image')) {
                return response.blob();
              } else {
                throw new Error('Tautan yang diberikan tidak mengarah ke gambar.');
              }
            })
            .then(blob => {
              const imgUrl = URL.createObjectURL(blob);

              const link = document.createElement('a');
              link.href = imgUrl;
              link.download = `${this.models.user.name}_${type}`;
              document.body.appendChild(link);

              link.click();

              link.parentNode.removeChild(link);
            })
            .catch(error => {
              const link = document.createElement('a')
              link.href = type === 'ktp' ? this.models.ktpUrl : this.models.npwpUrl
              link.target = '_blank';
              link.download = `img-${type}.jpg`

              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            });
        }
      },
		}
	}
</script>
